interface StarIconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
}

const StarIcon: React.FC<StarIconProps> = ({
  width = 115,
  height = 82,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 115 82"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M65.5092 78.0366C46.3329 78.0366 30.7495 62.6175 30.7495 43.6698C30.7495 24.722 46.3329 9.3457 65.5092 9.3457C84.6855 9.3457 100.269 24.7648 100.269 43.6698C100.269 50.556 98.2345 57.207 94.317 62.8956C91.8496 66.5097 88.7112 69.6107 85.0535 72.07C79.2746 75.9622 72.5218 78.0366 65.5092 78.0366Z"
      fill="#EAF0F0"
    />
    <path
      d="M64.1681 57.9599C64.3561 57.9599 64.5441 58.0041 64.7321 58.0926L75.5199 63.8881C76.214 64.2567 77.0383 63.6521 76.9081 62.8705L74.8547 50.6013C74.7824 50.2179 74.9125 49.805 75.2018 49.5248L83.9361 40.839C84.5001 40.2786 84.1964 39.2906 83.4011 39.1874L71.3118 37.3883C70.9358 37.3293 70.6032 37.0786 70.4441 36.7247L65.0213 25.5615C64.6743 24.8389 63.662 24.8389 63.315 25.5615L57.9066 36.7247C57.7475 37.0786 57.4149 37.3293 57.01 37.3883L44.9352 39.1874C44.1543 39.3054 43.8362 40.2786 44.4146 40.839L53.149 49.5248C53.4382 49.805 53.5683 50.2179 53.496 50.6013L51.4426 62.8705C51.3125 63.6669 52.1223 64.2715 52.8308 63.8881L63.6186 58.0926C63.7922 58.0041 63.9946 57.9599 64.1681 57.9599Z"
      fill="#FFE9D9"
    />
    <path
      d="M73.5302 76.6054C70.3025 77.5503 66.9334 78.0373 63.5034 78.0373C43.9583 78.0373 28.0752 62.3217 28.0752 43.0095C28.0752 23.6974 43.9583 8.02539 63.5034 8.02539C83.0484 8.02539 98.9315 23.741 98.9315 43.0095C98.9315 47.8337 97.9519 52.5446 96.0427 56.9016"
      stroke="#1A1A1A"
      stroke-linecap="round"
    />
    <path
      d="M73.5302 76.6054C70.3025 77.5503 66.9334 78.0373 63.5034 78.0373C43.9583 78.0373 28.0752 62.3217 28.0752 43.0095C28.0752 23.6974 43.9583 8.02539 63.5034 8.02539C83.0484 8.02539 98.9315 23.741 98.9315 43.0095C98.9315 47.8337 97.9519 52.5446 96.0427 56.9016"
      stroke="black"
      stroke-opacity="0.2"
      stroke-linecap="round"
    />
    <path
      d="M73.5302 76.6054C70.3025 77.5503 66.9334 78.0373 63.5034 78.0373C43.9583 78.0373 28.0752 62.3217 28.0752 43.0095C28.0752 23.6974 43.9583 8.02539 63.5034 8.02539C83.0484 8.02539 98.9315 23.741 98.9315 43.0095C98.9315 47.8337 97.9519 52.5446 96.0427 56.9016"
      stroke="black"
      stroke-opacity="0.2"
      stroke-linecap="round"
    />
    <path
      d="M73.5302 76.6054C70.3025 77.5503 66.9334 78.0373 63.5034 78.0373C43.9583 78.0373 28.0752 62.3217 28.0752 43.0095C28.0752 23.6974 43.9583 8.02539 63.5034 8.02539C83.0484 8.02539 98.9315 23.741 98.9315 43.0095C98.9315 47.8337 97.9519 52.5446 96.0427 56.9016"
      stroke="black"
      stroke-opacity="0.2"
      stroke-linecap="round"
    />
    <path
      d="M76.3817 58.3042L74.6231 48.393L83.8179 39.7039C84.1779 39.3682 84.3302 38.8579 84.1502 38.3878C83.9979 37.9312 83.5825 37.582 83.0978 37.5149L70.358 35.7287L64.6805 24.5417C64.2374 23.6554 62.7557 23.6554 62.3126 24.5417L56.6351 35.7287L43.923 37.5149C43.4106 37.582 42.9952 37.9312 42.8429 38.3878C42.6906 38.8444 42.829 39.3682 43.1891 39.7039L46.7202 43.0345M52.37 48.4064L50.2098 60.6947C50.1267 61.1781 50.3344 61.675 50.7222 61.9436C50.9576 62.1048 51.2345 62.1854 51.5115 62.1854C51.7192 62.1854 51.9407 62.1316 52.1208 62.0376L63.5035 56.236L74.8862 62.0376C75.3293 62.2659 75.8555 62.2256 76.2848 61.9302C76.6864 61.6482 76.8941 61.1647 76.811 60.6812L76.3817 58.2907"
      stroke="#1A1A1A"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M76.3817 58.3042L74.6231 48.393L83.8179 39.7039C84.1779 39.3682 84.3302 38.8579 84.1502 38.3878C83.9979 37.9312 83.5825 37.582 83.0978 37.5149L70.358 35.7287L64.6805 24.5417C64.2374 23.6554 62.7557 23.6554 62.3126 24.5417L56.6351 35.7287L43.923 37.5149C43.4106 37.582 42.9952 37.9312 42.8429 38.3878C42.6906 38.8444 42.829 39.3682 43.1891 39.7039L46.7202 43.0345M52.37 48.4064L50.2098 60.6947C50.1267 61.1781 50.3344 61.675 50.7222 61.9436C50.9576 62.1048 51.2345 62.1854 51.5115 62.1854C51.7192 62.1854 51.9407 62.1316 52.1208 62.0376L63.5035 56.236L74.8862 62.0376C75.3293 62.2659 75.8555 62.2256 76.2848 61.9302C76.6864 61.6482 76.8941 61.1647 76.811 60.6812L76.3817 58.2907"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M76.3817 58.3042L74.6231 48.393L83.8179 39.7039C84.1779 39.3682 84.3302 38.8579 84.1502 38.3878C83.9979 37.9312 83.5825 37.582 83.0978 37.5149L70.358 35.7287L64.6805 24.5417C64.2374 23.6554 62.7557 23.6554 62.3126 24.5417L56.6351 35.7287L43.923 37.5149C43.4106 37.582 42.9952 37.9312 42.8429 38.3878C42.6906 38.8444 42.829 39.3682 43.1891 39.7039L46.7202 43.0345M52.37 48.4064L50.2098 60.6947C50.1267 61.1781 50.3344 61.675 50.7222 61.9436C50.9576 62.1048 51.2345 62.1854 51.5115 62.1854C51.7192 62.1854 51.9407 62.1316 52.1208 62.0376L63.5035 56.236L74.8862 62.0376C75.3293 62.2659 75.8555 62.2256 76.2848 61.9302C76.6864 61.6482 76.8941 61.1647 76.811 60.6812L76.3817 58.2907"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M76.3817 58.3042L74.6231 48.393L83.8179 39.7039C84.1779 39.3682 84.3302 38.8579 84.1502 38.3878C83.9979 37.9312 83.5825 37.582 83.0978 37.5149L70.358 35.7287L64.6805 24.5417C64.2374 23.6554 62.7557 23.6554 62.3126 24.5417L56.6351 35.7287L43.923 37.5149C43.4106 37.582 42.9952 37.9312 42.8429 38.3878C42.6906 38.8444 42.829 39.3682 43.1891 39.7039L46.7202 43.0345M52.37 48.4064L50.2098 60.6947C50.1267 61.1781 50.3344 61.675 50.7222 61.9436C50.9576 62.1048 51.2345 62.1854 51.5115 62.1854C51.7192 62.1854 51.9407 62.1316 52.1208 62.0376L63.5035 56.236L74.8862 62.0376C75.3293 62.2659 75.8555 62.2256 76.2848 61.9302C76.6864 61.6482 76.8941 61.1647 76.811 60.6812L76.3817 58.2907"
      stroke="black"
      stroke-opacity="0.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M86.2309 82.0003C78.4867 82.0003 72.1934 75.7734 72.1934 68.1214C72.1934 60.4694 78.4867 54.2598 86.2309 54.2598C93.9752 54.2598 100.269 60.4867 100.269 68.1214C100.269 70.9024 99.4469 73.5883 97.8648 75.8857C96.8684 77.3452 95.601 78.5975 94.1238 79.5907C91.79 81.1626 89.0629 82.0003 86.2309 82.0003Z"
      fill="white"
    />
    <path
      d="M96.2306 74.5723L96.2294 74.5739C95.3168 75.9107 94.1555 77.0585 92.8005 77.9696L92.8002 77.9698C90.6599 79.4114 88.1598 80.1794 85.5625 80.1794C78.4579 80.1794 72.6934 74.4676 72.6934 67.4613C72.6934 60.4559 78.4571 54.7598 85.5625 54.7598C92.6675 54.7598 98.4316 60.472 98.4316 67.4613C98.4316 70.0101 97.679 72.469 96.2306 74.5723Z"
      stroke="#1A1A1A"
    />
    <path
      d="M96.2306 74.5723L96.2294 74.5739C95.3168 75.9107 94.1555 77.0585 92.8005 77.9696L92.8002 77.9698C90.6599 79.4114 88.1598 80.1794 85.5625 80.1794C78.4579 80.1794 72.6934 74.4676 72.6934 67.4613C72.6934 60.4559 78.4571 54.7598 85.5625 54.7598C92.6675 54.7598 98.4316 60.472 98.4316 67.4613C98.4316 70.0101 97.679 72.469 96.2306 74.5723Z"
      stroke="black"
      stroke-opacity="0.2"
    />
    <path
      d="M96.2306 74.5723L96.2294 74.5739C95.3168 75.9107 94.1555 77.0585 92.8005 77.9696L92.8002 77.9698C90.6599 79.4114 88.1598 80.1794 85.5625 80.1794C78.4579 80.1794 72.6934 74.4676 72.6934 67.4613C72.6934 60.4559 78.4571 54.7598 85.5625 54.7598C92.6675 54.7598 98.4316 60.472 98.4316 67.4613C98.4316 70.0101 97.679 72.469 96.2306 74.5723Z"
      stroke="black"
      stroke-opacity="0.2"
    />
    <path
      d="M96.2306 74.5723L96.2294 74.5739C95.3168 75.9107 94.1555 77.0585 92.8005 77.9696L92.8002 77.9698C90.6599 79.4114 88.1598 80.1794 85.5625 80.1794C78.4579 80.1794 72.6934 74.4676 72.6934 67.4613C72.6934 60.4559 78.4571 54.7598 85.5625 54.7598C92.6675 54.7598 98.4316 60.472 98.4316 67.4613C98.4316 70.0101 97.679 72.469 96.2306 74.5723Z"
      stroke="black"
      stroke-opacity="0.2"
    />
    <path
      d="M85.5625 59.5449V75.3967M93.584 67.4708L77.541 67.4708"
      stroke="#1A1A1A"
      stroke-linecap="round"
    />
    <path
      d="M85.5625 59.5449V75.3967M93.584 67.4708L77.541 67.4708"
      stroke="black"
      stroke-opacity="0.2"
      stroke-linecap="round"
    />
    <path
      d="M85.5625 59.5449V75.3967M93.584 67.4708L77.541 67.4708"
      stroke="black"
      stroke-opacity="0.2"
      stroke-linecap="round"
    />
    <path
      d="M85.5625 59.5449V75.3967M93.584 67.4708L77.541 67.4708"
      stroke="black"
      stroke-opacity="0.2"
      stroke-linecap="round"
    />
    <path
      d="M1.46996 38.8161L5.14417 38.1301M7.87329 29.4728L8.55929 33.1471M13.5424 36.5622L17.2166 35.8762M10.1273 41.5453L10.8133 45.2195"
      stroke="#1A1A1A"
      stroke-linecap="round"
    />
    <path
      d="M1.46996 38.8161L5.14417 38.1301M7.87329 29.4728L8.55929 33.1471M13.5424 36.5622L17.2166 35.8762M10.1273 41.5453L10.8133 45.2195"
      stroke="black"
      stroke-opacity="0.2"
      stroke-linecap="round"
    />
    <path
      d="M1.46996 38.8161L5.14417 38.1301M7.87329 29.4728L8.55929 33.1471M13.5424 36.5622L17.2166 35.8762M10.1273 41.5453L10.8133 45.2195"
      stroke="black"
      stroke-opacity="0.2"
      stroke-linecap="round"
    />
    <path
      d="M1.46996 38.8161L5.14417 38.1301M7.87329 29.4728L8.55929 33.1471M13.5424 36.5622L17.2166 35.8762M10.1273 41.5453L10.8133 45.2195"
      stroke="black"
      stroke-opacity="0.2"
      stroke-linecap="round"
    />
    <path
      d="M97.7626 7.86744L101.434 8.56919M107.133 1.50426L106.431 5.17551M109.825 10.1732L113.496 10.875M104.827 13.5669L104.126 17.2381"
      stroke="#1A1A1A"
      stroke-linecap="round"
    />
    <path
      d="M97.7626 7.86744L101.434 8.56919M107.133 1.50426L106.431 5.17551M109.825 10.1732L113.496 10.875M104.827 13.5669L104.126 17.2381"
      stroke="black"
      stroke-opacity="0.2"
      stroke-linecap="round"
    />
    <path
      d="M97.7626 7.86744L101.434 8.56919M107.133 1.50426L106.431 5.17551M109.825 10.1732L113.496 10.875M104.827 13.5669L104.126 17.2381"
      stroke="black"
      stroke-opacity="0.2"
      stroke-linecap="round"
    />
    <path
      d="M97.7626 7.86744L101.434 8.56919M107.133 1.50426L106.431 5.17551M109.825 10.1732L113.496 10.875M104.827 13.5669L104.126 17.2381"
      stroke="black"
      stroke-opacity="0.2"
      stroke-linecap="round"
    />
  </svg>
);

export default StarIcon;
